import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'

const useStyles = makeStyles((theme) => ({
    ...styles(theme),
    label: {
        marginTop: 30,
        fontWeight: 'bold'
    },
    value: {
        wordBreak: 'break-word'
    }
}))

interface AcceptingProps {
    label: string,
    value: string
}

type DisplayTextProps = AcceptingProps

const DisplayInfo: React.FC<DisplayTextProps> = (
    {
        label,
        value
    }
) => {
    const classes = useStyles()

    const labelClass: ClassValue = classNames(
        classes.text2,
        classes.colorBlue,
        classes.label
    )

    const valueClass: ClassValue = classNames(
        classes.text2_opacity,
        classes.value
    )

    return (
        <>
            <p className={labelClass}>{label}</p>
            <p className={valueClass}>{value}</p>
        </>
    )
}

export default DisplayInfo
